import { createStore } from 'vuex'
import auth from './modules/auth'

const demoTickets = {
  10: Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    title: `${i + 1}-bilet`,
    questions: Array.from({ length: 10 }, (_, qIndex) => ({
      id: `${i + 1}-${qIndex + 1}`,
      question: `10 talik ${i + 1}-bilet, ${qIndex + 1}-savol matni`,
      image: 'https://via.placeholder.com/500x280?text=Savol+Rasmi',
      explanation: `Bu ${qIndex + 1}-savol uchun izoh.`,
      correctAnswer: 0,
      options: [
        'Variant A',
        'Variant B',
        'Variant C',
        'Variant D',
        'Variant E',
        'Variant F'
      ]
    }))
  })),
  20: Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    title: `${i + 1}-bilet`,
    questions: Array.from({ length: 20 }, (_, qIndex) => ({
      id: `${i + 1}-${qIndex + 1}`,
      question: `20 talik ${i + 1}-bilet, ${qIndex + 1}-savol matni`,
      image: 'https://via.placeholder.com/500x280?text=Savol+Rasmi',
      explanation: `Bu ${qIndex + 1}-savol uchun izoh.`,
      correctAnswer: 1,
      options: [
        'Variant A',
        'Variant B',
        'Variant C',
        'Variant D',
        'Variant E',
        'Variant F'
      ]
    }))
  })),
  50: Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    title: `${i + 1}-bilet`,
    questions: Array.from({ length: 50 }, (_, qIndex) => ({
      id: `${i + 1}-${qIndex + 1}`,
      question: `50 talik ${i + 1}-bilet, ${qIndex + 1}-savol matni`,
      image: 'https://via.placeholder.com/500x280?text=Savol+Rasmi',
      explanation: `Bu ${qIndex + 1}-savol uchun izoh.`,
      correctAnswer: 2,
      options: [
        'Variant A',
        'Variant B',
        'Variant C',
        'Variant D',
        'Variant E',
        'Variant F'
      ]
    }))
  })),
  realExam: {
    id: 'real-exam',
    title: 'Real imtihon',
    questions: Array.from({ length: 20 }, (_, qIndex) => ({
      id: `real-${qIndex + 1}`,
      question: `Real imtihon ${qIndex + 1}-savol`,
      image: 'https://via.placeholder.com/500x280?text=Real+Exam',
      explanation: `Bu real imtihondagi ${qIndex + 1}-savol izohi.`,
      correctAnswer: qIndex % 4,
      options: [
        'Variant A',
        'Variant B',
        'Variant C',
        'Variant D',
        'Variant E',
        'Variant F'
      ]
    }))
  }
}

export default createStore({
  state() {
    return {
      theme: localStorage.getItem('theme') || 'dark',
      tickets: demoTickets,
      wrongQuestions: [],
      lastResult: null,
      medicalInfo: [
        { id: 1, title: 'Birinchi tibbiy yordam', text: 'Birinchi yordam qoidalari...' },
        { id: 2, title: 'Qon ketishda yordam', text: 'Qon ketganda qilinadigan ishlar...' }
      ],
      roadSigns: [
        { id: 1, name: 'To‘xtash taqiqlanadi', image: 'https://via.placeholder.com/120', desc: 'Bu belgi to‘xtashni taqiqlaydi.' },
        { id: 2, name: 'Piyodalar o‘tish joyi', image: 'https://via.placeholder.com/120', desc: 'Piyodalar o‘tish joyi belgisi.' }
      ],
      fines: [
        { id: 1, title: 'Tezlikni oshirish', amount: '300 000 so‘m' },
        { id: 2, title: 'Qizil chiroqda o‘tish', amount: '450 000 so‘m' }
      ]
    }
  },

  getters: {
    currentTheme: state => state.theme,
    getTicketsByType: state => type => state.tickets[type] || [],
    getRealExam: state => state.tickets.realExam,
    wrongQuestions: state => state.wrongQuestions,
    medicalInfo: state => state.medicalInfo,
    roadSigns: state => state.roadSigns,
    fines: state => state.fines,
    lastResult: state => state.lastResult
  },

  mutations: {
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('theme', theme)
    },
    ADD_WRONG_QUESTION(state, question) {
      const exists = state.wrongQuestions.find(item => item.id === question.id)
      if (!exists) {
        state.wrongQuestions.push(question)
      }
    },
    SET_LAST_RESULT(state, payload) {
      state.lastResult = payload
    },
    CLEAR_LAST_RESULT(state) {
      state.lastResult = null
    },
  },

  actions: {
    toggleTheme({ commit, state }) {
      const next = state.theme === 'light' ? 'dark' : 'light'
      commit('SET_THEME', next)
    },
    addWrongQuestion({ commit }, question) {
      commit('ADD_WRONG_QUESTION', question)
    },
    saveResult({ commit }, payload) {
      commit('SET_LAST_RESULT', payload)
    },
    clearResult({ commit }) {
      commit('CLEAR_LAST_RESULT')
    },
  },
  modules: {
    auth,   // ← shu nom bilan bo‘lishi shart – "auth"
  },
})